import { Inject, Injectable } from "@angular/core";
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { Router } from "@angular/router";
import { BaseFpxComponentState, BaseFpxFormHelper, HttpRequest } from "@fpx/core";
import { CommonService } from "src/app/common.service";
import { IPopupScreenData } from "src/app/common/models/popup-screen-data.model";
import { ProcessShellService } from "src/app/process-shell/services/process-shell.service";
import { environment } from "src/environments/environment";
import { SettingsResultPageComponent } from "./settings-result-page.component";
import { HttpProviderService } from  '@fpx/core';
import { interval } from 'rxjs';
import { take} from 'rxjs/operators';
import { PreLoginService } from "src/app/pre-login/pre-login.service";
export class SettingsResultPageState extends BaseFpxComponentState {
  showSuggestion: boolean = false;
  resultData: any;
  isAlreadyFav: boolean = false;
}

@Injectable()
export class SettingsResultPageHelper extends BaseFpxFormHelper<SettingsResultPageState>{
  private accountsModules: string[] = ['casa-accounts', 'deposits', 'loans'];
  private cardsModules: string[] = ['debit-card', 'credit-card'];
  private commonModules = new Map<any,any>()

  constructor(
    public _httpProvider : HttpProviderService,
    private _processShellService: ProcessShellService,
    private _router: Router,
    private _matDialog: MatDialog,
    private _preLoginService: PreLoginService,
    private _commonService: CommonService,

    @Inject(MAT_DIALOG_DATA) private data: IPopupScreenData
  ) {
    super(new SettingsResultPageState());
    this.state.resultData = this._router.getCurrentNavigation()?.extras?.queryParams;

    this.commonModules.set('bill-payments','payments')
  }

  public doPreInit(): void {
    this._processShellService.formClassName = this._processShellService.formClassName + " result-info";
    this._processShellService.setFooterVisible(false);
    this._processShellService.setHeaderBackbtnVisible(false);
  }

  public doPostInit(): void {
    if(this._processShellService.autoLogOutRequired){
      setTimeout(() => {
        this._processShellService.autoLogOutRequired = false;
        this._preLoginService.logout();
      }, 2000);
      // interval(5000).pipe(take(1),).subscribe(value =>{
        
      // })
    }
  }

  public doDestroy(): void {
    this._processShellService.autoLogOutRequired = false;
    this._processShellService.closeNavigation = []
    this._processShellService.resultIconData =  undefined;
    this._processShellService.formClassName = this._processShellService.formClassName.replace(' result-info', '');
  }

  iconClick(iconData){
    // TEMP FIX
    if(iconData?.icon == 'favourite'){
      this._processShellService.resultIconClick.emit({service:iconData?.service,resultData:this.state.resultData});
    }
  }

  onClose() {
    this._matDialog.closeAll();
    this._router.navigate(['home','settings'], {
      queryParams: {},
      queryParamsHandling: 'preserve'
    });
  }

}
